"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PhoneFilled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13.8191069,15.1559175 L14.3342822,14.125567 C14.539494,13.7151433 14.9976992,13.4970512 15.4456398,13.5965936 L19.0764544,14.4034412 C19.6155876,14.5232486 19.9555184,15.0574255 19.835711,15.5965588 L19.0413492,19.1712874 C18.9310269,19.6677377 18.465678,20.0023253 17.9599392,19.948825 C17.73603,19.9251385 17.5737274,19.906845 17.4730313,19.8939444 C13.4075295,19.3730983 10.2790903,18.0301144 8.10252929,15.8535534 C5.88461622,13.6356403 4.53225502,10.4293363 4.03334204,6.25031753 C4.02670102,6.19469067 4.0174079,6.10962011 4.00546267,5.99510584 C3.95271286,5.48983669 4.28720831,5.02533072 4.78312619,4.91512675 L8.35952393,4.1203717 C8.89865715,4.00056432 9.43283406,4.34049507 9.55264144,4.8796283 L10.3594891,8.51044286 C10.4590315,8.95838351 10.2409394,9.41658866 9.83051566,9.62180051 L8.8001652,10.1369757 L13.8191069,15.1559175 Z" })));
};
PhoneFilled.displayName = 'PhoneFilled';
exports.default = PhoneFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PhoneFilled.js.map